import deepEqual from 'fast-deep-equal';
function pruneFieldState(fieldState) {
    if (!fieldState)
        return fieldState;
    const prunedFieldState = {};
    Object.entries(fieldState).forEach((key, value) => {
        if (typeof value !== 'function')
            prunedFieldState[key] = value;
    });
    return prunedFieldState;
}
export default function memoizeValidator(unmemoizedValidator) {
    if (!unmemoizedValidator)
        return unmemoizedValidator;
    let lastValue = undefined;
    let lastFormValues = undefined;
    let lastFieldState = undefined;
    let lastResult = undefined;
    return (value, formValues, fieldState) => {
        // some parts of fieldState are functions and cannot be memoized correctly,
        // so we prune off all functions before comparison
        const prunedFieldState = pruneFieldState(fieldState);
        // deep equality is needed to ensure that complex field values like arrays
        // are correclty memoized
        const hasChanged = !deepEqual(value, lastValue) ||
            !deepEqual(lastFormValues, formValues) ||
            !deepEqual(lastFieldState, prunedFieldState);
        if (!hasChanged) {
            return lastResult;
        }
        lastValue = value;
        lastFormValues = formValues;
        lastFieldState = prunedFieldState;
        // if lastResult is a promise, this still works:
        // we just memoize the promise (not the resolved value)
        // and next time we return it, it will be already resolved
        lastResult = unmemoizedValidator(value, lastFormValues, fieldState);
        return lastResult;
    };
}
//# sourceMappingURL=memoizeValidator.js.map